export default {
  parentCompanyDetail: '总公司详情',
  parentCompanyJobList: '总公司职位列表',
  companyDetail: '公司详情',
  companyJobList: '公司职位列表',
  myReward: '我的奖励',
  myRedeem: '我的兑现',
  personalInfo: '我的个人信息',
  aboutPlan: '关于推荐计划',
  jobDescription: '工作描述',
  myPreference: '我的偏好',
  logout: '退出',
  downloadApp: '扫码解锁掌上AJINGA'
}
